import { render, staticRenderFns } from "./BrandReport.vue?vue&type=template&id=a304edb0&scoped=true"
import script from "./BrandReport.vue?vue&type=script&lang=js"
export * from "./BrandReport.vue?vue&type=script&lang=js"
import style0 from "./BrandReport.vue?vue&type=style&index=0&id=a304edb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a304edb0",
  null
  
)

export default component.exports